<template>
  <div>
    <div v-if="isSearch" class="drag-panel-container" :class="{'drag-panel-fullScreen': currentStateIndex === 2, 'drag-custom': isBottom}" :style="{ 'z-index': posIndex ? 95 : 96 }">
      <div class="drag-panel" :style="{ height: panelHeight + 'px' }" @touchstart.stop="onTouchStart" @touchmove.stop="onTouchMove" @touchend.stop="onTouchEnd">
        <div v-show="currentStateIndex !== 2" class="scroll-size"></div>

        <div class="header-info" id="headerInfo">
          <div class="left-item">
            <span class="txt-ellipsis">{{ $t('shared.nearbyStores') }}</span>
            <van-icon v-show="listRefresh" size="16" name="replay" @click="handleRefresh" />
          </div>
          <div class="right-item" @click="handleAddress">
            <img class="icon-img" src="@/assets/images/ditu.png" alt="">
            <span class="txt-ellipsis">{{ cureentPos || $t('shared.locationName') }} ></span>
          </div>
        </div>
        <ListItem ref="listItemRef" :mapData="mapData" :pageType="pageType" v-on="$listeners" @handleListItem="handleListItem" :currentStateIndex="currentStateIndex" @handleHeight="handleHeight" />
      </div>
      <!-- <ListDetails ref="listDetailsRef" :detailsData="detailsData" :currentAddres="currentAddres" /> -->
    </div>
    <div v-else class="map-address-search">
      <div class="custom-autocomplete-container">
        <input ref="autocompleteInput" v-model="searchVal" type="text" :placeholder="$t('form.cityNeighborhoodStreetOrBuilding')" class="custom-input" />
        <div @click="isSearch = true">{{ $t('button.cancel') }}</div>
      </div>
      <!-- <div id="address-map"></div> -->
    </div>
  </div>
</template>

<script>
import ListItem from './listItem'

let map
let marker
let infoWindow
let center = { lat: 40.749933, lng: -73.98633 } // New York City
async function initMap () {
  const [{ Map }, { AdvancedMarkerElement }] = await Promise.all([
    google.maps.importLibrary('marker'),
    google.maps.importLibrary('places')
  ])

  map = new google.maps.Map(document.getElementById('address-map'), {
    center,
    zoom: 13,
    mapTypeControl: false
  })
}
export default {
  name: 'MapList',
  components: {
    ListItem
    // ListDetails: () => import('./listDetails')
  },
  props: {
    currentAddres: {
      type: String,
      default: ''
    },
    mapData: {
      type: Array,
      default: () => []
    },
    isBottom: {
      type: Boolean,
      default: false
    },
    posIndex: {
      type: Boolean,
      default: false
    },
    listRefresh: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      screenHeight: window.innerHeight, // 屏幕高度
      states: [
        { height: 0.25, label: '1/3 高度' },
        { height: 0.5, label: '1/2 高度' },
        { height: 0.85, label: '全屏' }
        // { height: 0.33, label: '1/3 高度' },
        // { height: 0.5, label: '1/2 高度' },
        // { height: 1, label: '全屏' }
      ],
      currentStateIndex: 0,
      panelHeight: 0,
      startY: 0,
      startHeight: 0,
      isDragging: false,
      dragStartTime: 0,
      lastY: 0,
      velocity: 0,
      detailsData: {},
      isSearch: true,
      searchVal: '',
      autocomplete: null,
      cureentPos: ''
    }
  },
  computed: {
    minHeight () {
      return this.screenHeight * this.states[0].height
    },
    maxHeight () {
      return this.screenHeight * this.states[2].height
    },
    midHeight () {
      return this.screenHeight * this.states[1].height
    }
  },
  mounted () {
    this.isSearch = true
    this.calculatePanelHeight()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    isSearch (newVal) {
      if (!newVal) {
        // map && map.destroy()
        this.searchVal = ''
      }
    }
  },
  methods: {
    initAutocomplete () {
      this.$nextTick(() => {
        // 如果库还没加载完，就等它
        if (
          !window.google ||
          !window.google.maps ||
          !window.google.maps.places
        ) {
          const timer = setInterval(() => {
            if (
              window.google &&
              window.google.maps &&
              window.google.maps.places
            ) {
              clearInterval(timer)
              this.createAutocomplete()
            }
          }, 100)
          return
        }
        this.createAutocomplete() // 已经加载完直接创建
      })
    },
    createAutocomplete () {
      if (this.autocomplete) {
        google.maps.event.clearInstanceListeners(this.autocomplete)
      }
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocompleteInput,
        {
          types: ['geocode'],
          componentRestrictions: { country: 'us' } // ← 只返回美国
        }
        // { types: ['geocode'] }
      )
      this.autocomplete.addListener('place_changed', this.handlePlaceSelect)
    },
    handlePlaceSelect (val) {
      const place = this.autocomplete.getPlace()
      if (!place || !place.geometry) return
      this.$emit('mapGoTo', {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      })
      this.cureentPos = place.formatted_address.split(',')[0]
      this.searchVal = ''
      this.isSearch = true
    },
    handleAddress () {
      this.$emit('clearRequest')
      this.isSearch = false
      this.$nextTick(() => {
        if (!map) initMap()
        this.initAutocomplete()
        this.$refs.autocompleteInput.focus()
      })
    },
    handleRefresh () {
      this.$emit('mapListRefresh')
      this.$refs.listItemRef.resetScroll(1)
    },
    handleListItem (params) {
      this.$emit('clearRequest')
      this.detailsData = params.data
      if (params.type === 'details') {
        // this.$refs.listDetailsRef.detailsPopup = true
      }
      if (this.pageType === 'storeMaintain') {
        this.$router.push(`/storeMaintain/workItem?customerId=${params.data.id}`)
      } else {
        this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${params.data.id}`)
      }
    },
    handleHeight () {
      this.currentStateIndex = 0
      this.calculatePanelHeight()
    },
    calculatePanelHeight () {
      this.panelHeight =
        this.screenHeight * this.states[this.currentStateIndex].height
    },
    handleResize () {
      this.screenHeight = window.innerHeight
      this.calculatePanelHeight()
    },
    onTouchStart (e) {
      // // 如果点在了可滚动子节点里，直接 return
      // if (e.target.closest('.scroll-area')) return;
      this.isDragging = true
      this.startY = e.touches[0].clientY
      this.startHeight = this.panelHeight
      this.dragStartTime = Date.now()
      this.lastY = this.startY
      this.velocity = 0
    },
    onTouchMove (e) {
      if (!this.isDragging) return

      const currentY = e.touches[0].clientY
      const deltaY = this.startY - currentY // 反转计算方式
      const deltaTime = Date.now() - this.dragStartTime

      // 计算速度
      if (deltaTime > 0) {
        this.velocity = (this.lastY - currentY) / deltaTime
        this.lastY = currentY
      }

      // 计算新高度
      let newHeight = this.startHeight + deltaY

      // 应用边界限制
      if (newHeight < this.minHeight) {
        newHeight = this.minHeight
      } else if (newHeight > this.maxHeight) {
        newHeight = this.maxHeight
      }

      this.panelHeight = newHeight

      // 计算拖拽进度（用于顶部进度条）
      // const heightRange = this.maxHeight - this.minHeight;
      // const currentProgress = (newHeight - this.minHeight) / heightRange;
      // this.dragProgress = Math.min(1, Math.max(0, currentProgress));

      e.preventDefault()
    },
    onTouchEnd () {
      if (!this.isDragging) return
      this.isDragging = false

      // 计算拖拽距离
      const deltaHeight = this.panelHeight - this.startHeight
      const absDelta = Math.abs(deltaHeight)

      // 根据拖拽距离、速度和当前状态决定下一个状态
      let targetStateIndex = this.currentStateIndex
      // let transitionMsg = '';

      if (this.currentStateIndex === 0) {
        // 当前是1/3
        if (deltaHeight > 0) {
          // 向上拖拽：轻拉切换到1/2，大幅度或快速切换到全屏
          if (absDelta > this.screenHeight * 0.15 || this.velocity > 0.2) {
            targetStateIndex = 2 // 全屏
            // transitionMsg = '1/3 → 全屏';
          } else {
            targetStateIndex = 1 // 1/2
            // transitionMsg = '1/3 → 1/2';
          }
        }
      } else if (this.currentStateIndex === 1) {
        // 当前是1/2
        if (deltaHeight > 0) {
          targetStateIndex = 2 // 向上拖拽：切换到全屏
          // transitionMsg = '1/2 → 全屏';
        } else if (deltaHeight < 0) {
          targetStateIndex = 0 // 向下拖拽：切换到1/3
          // transitionMsg = '1/2 → 1/3';
        }
      } else if (this.currentStateIndex === 2) {
        // 当前是全屏
        if (deltaHeight < 0) {
          // 向下拖拽：轻拉切换到1/2，大幅度或快速切换到1/3
          if (absDelta > this.screenHeight * 0.15 || this.velocity < -0.2) {
            targetStateIndex = 0 // 1/3
            // transitionMsg = '全屏 → 1/3';
          } else {
            targetStateIndex = 1 // 1/2
            // transitionMsg = '全屏 → 1/2';
          }
        }
      }

      this.currentStateIndex = targetStateIndex
      if (this.currentStateIndex === 2) {
        this.panelHeight = this.screenHeight - document.getElementById('headerInfo').offsetHeight - 5
        this.$refs.listItemRef.resetScroll(1)
      } else {
        this.panelHeight =
          this.screenHeight * this.states[this.currentStateIndex].height
      }
      // this.dragProgress = this.currentStateIndex / (this.states.length - 1);
    }
  }
}
</script>

<style lang="less" scoped>
.drag-panel-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  z-index: 96;
  font-size: 11px;
  // box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.15);
  .drag-panel {
    position: relative;
    background: white;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: height 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow: 0px -1px 0px 1px rgba(238, 238, 238, 0.3);
    .scroll-size {
      width: 30px;
      height: 5px;
      background-color: #e4e7eb;
      position: absolute;
      top: 5px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 5px;
    }
  }
  .header-info {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 10px 10px 10px;
    border-bottom: 1px solid #eee;
    .left-item,
    .right-item {
      display: flex;
      align-items: center;
      max-width: 160px;
      > span {
        font-size: 14px;
      }
    }
    .left-item {
      > span {
        font-weight: bold;
        margin-right: 5px;
      }
    }
    .right-item {
      font-size: 11px;
      > img {
        margin-right: 5px;
      }
    }
  }
  .icon-img {
    width: 16px;
    height: 16px;
  }
}
.drag-custom {
  bottom: 0;
}
.drag-panel-fullScreen {
  z-index: 100;
}
.map-address-search {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  z-index: 999 !important;
  .custom-autocomplete-container {
    padding: 10px;
    font-size: 11px;
    display: flex;
    align-items: center;
    .custom-input {
      flex: 1;
      padding: 7px 10px;
      border: none;
      border-radius: 15px;
      margin-right: 10px;
      background-color: #eee;
    }
  }
}
</style>